// ═══════════════════════════════════════════════════════════════
// AI POLICE — MODULE DEFINITIONS
// 13 Agent modules (4 categorieën) + 4 Burger modules
// ═══════════════════════════════════════════════════════════════

export const CATEGORIES = {
  kern:         { nl: 'Kern',         en: 'Core',          color: '#ef4444', icon: '🔴' },
  onderzoek:    { nl: 'Onderzoek',    en: 'Investigation',  color: '#f97316', icon: '🟠' },
  operationeel: { nl: 'Operationeel', en: 'Operational',    color: '#22c55e', icon: '🟢' },
  kennis:       { nl: 'Kennis',       en: 'Knowledge',      color: '#a855f7', icon: '🟣' },
};

export const AGENT_MODULES = {
  // ── KERN (Rood) ──
  aangifte: {
    icon: '📝', cat: 'kern',
    nl: 'Aangifte & PV',            en: 'Report & PV',
    descNl: 'Aangifte opnemen, proces-verbaal genereren',
    descEn: 'File reports, generate official statements',
  },
  dossier: {
    icon: '📋', cat: 'kern',
    nl: 'Dossiervorming',           en: 'Case File Assembly',
    descNl: 'Strafdossier samenstellen voor het OM',
    descEn: 'Assemble criminal case files for prosecution',
  },

  // ── ONDERZOEK (Oranje) ──
  verhoor: {
    icon: '🎙️', cat: 'onderzoek',
    nl: 'Verhoor Transcriptie',     en: 'Interview Transcript',
    descNl: 'Real-time transcriptie en samenvatting van verhoren',
    descEn: 'Real-time interview transcription & summary',
  },
  incident: {
    icon: '🚨', cat: 'onderzoek',
    nl: 'Incident Registratie',     en: 'Incident Registration',
    descNl: 'Spraak-gestuurde incidentregistratie',
    descEn: 'Voice-driven incident registration',
  },
  camera: {
    icon: '📹', cat: 'onderzoek',
    nl: 'Camerabeelden',            en: 'Camera Footage',
    descNl: 'Beeldmateriaal verwerken en beschrijven',
    descEn: 'Process & describe camera footage',
  },
  beslag: {
    icon: '🏷️', cat: 'onderzoek',
    nl: 'Beslagname',               en: 'Seizure',
    descNl: 'In beslag genomen goederen registreren',
    descEn: 'Register seized goods and evidence',
  },

  // ── OPERATIONEEL (Groen) ──
  signalering: {
    icon: '🔍', cat: 'operationeel',
    nl: 'Signaleringen',            en: 'Alerts',
    descNl: 'Personen, voertuigen en objecten signaleren',
    descEn: 'Flag persons, vehicles, and objects',
  },
  briefing: {
    icon: '📊', cat: 'operationeel',
    nl: 'Briefings',                en: 'Briefings',
    descNl: 'Dienst-overdracht en briefing genereren',
    descEn: 'Shift handover & briefing generation',
  },
  planning: {
    icon: '📅', cat: 'operationeel',
    nl: 'Planning & Roostering',    en: 'Scheduling',
    descNl: 'Dienstplanning en capaciteitsoverzicht',
    descEn: 'Shift planning & capacity overview',
  },
  vergunning: {
    icon: '📜', cat: 'operationeel',
    nl: 'Vergunningen',             en: 'Permits',
    descNl: 'Vergunningaanvragen en controles',
    descEn: 'Permit applications & checks',
  },

  // ── KENNIS (Paars) ──
  kennis: {
    icon: '⚖️', cat: 'kennis',
    nl: 'Wet & Procedures',         en: 'Law & Procedures',
    descNl: 'Wetgeving, protocollen en statistieken',
    descEn: 'Legislation, protocols & statistics',
  },
  slachtoffer: {
    icon: '🤝', cat: 'kennis',
    nl: 'Slachtofferhulp',          en: 'Victim Support',
    descNl: 'Doorverwijzing en ondersteuning slachtoffers',
    descEn: 'Victim referral & support services',
  },
};

export const BURGER_MODULES = {
  b_aangifte: {
    icon: '📝',
    nl: 'Aangifte Doen',            en: 'File a Report',
    descNl: 'Hulp bij het doen van aangifte',
    descEn: 'Help with filing a report',
  },
  b_rechten: {
    icon: '⚖️',
    nl: 'Rechten & Plichten',       en: 'Rights & Duties',
    descNl: 'Uw rechten bij politiecontact',
    descEn: 'Your rights during police contact',
  },
  b_cyber: {
    icon: '💻',
    nl: 'Cybercrime Hulp',          en: 'Cybercrime Help',
    descNl: 'Gehackt, phishing, identiteitsfraude',
    descEn: 'Hacked, phishing, identity fraud',
  },
  b_slachtoffer: {
    icon: '🤝',
    nl: 'Slachtofferhulp',          en: 'Victim Support',
    descNl: 'Hulporganisaties en schadevergoeding',
    descEn: 'Support organizations & compensation',
  },
};
